import { apiClient } from '@/lib/api-client';
import type { ReportSummary } from '@/types/api';

export const reportsApi = {
  /** Revenue and work of `year` (work types for `month` when given), optionally of one doctor. */
  async summary(params: { year: number; month: number | null; dentistId: string | null }) {
    const { data } = await apiClient.get<ReportSummary>('/reports/summary', {
      params: {
        year: params.year,
        month: params.month ?? undefined,
        dentistId: params.dentistId ?? undefined,
      },
    });
    return data;
  },
};
